/**
 * Escapes a VALUE for interpolation inside single quotes in SQL (`'` → `''`).
 *
 * THE canonical copy (PLATFORM.md §3.2 rule 6): escape every value you splice
 * into a query, and never "escape" SQL fragments, identifiers or table names —
 * those must be built from trusted constants. Its one home is this package,
 * `@rdrive/helper-sql` — nothing re-exports it (PLATFORM.md §6 decision 21).
 *
 * @param {unknown} value  coerced with `String()` first (numbers, dates, null)
 * @returns {string} the escaped text, WITHOUT the surrounding quotes
 */
export const escapeSql = (value) => String(value).replace(/'/g, "''");
